import React from "react";
import Card from "components/card";
import Chart from "react-apexcharts";

const CrawlerTopRetailersChart = ({ rows, limit = 10 }) => {
  const retailerData = React.useMemo(() => {
    const map = {};
    (rows || []).forEach((row) => {
      const name = row?.retailerName || row?.retailerNo;
      if (!name) return;
      if (!map[name]) map[name] = 0;
      map[name]++;
    });
    return Object.entries(map)
      .sort(([, a], [, b]) => b - a)
      .slice(0, limit)
      .map(([name, count]) => ({ name, count }));
  }, [rows, limit]);

  if (retailerData.length === 0) {
    return (
      <Card extra="p-5">
        <h4 className="text-base font-bold text-navy-700 dark:text-white mb-4 font-dm">
          Top Retailers by Crawl Count
        </h4>
        <div className="flex items-center justify-center h-64">
          <p className="text-gray-500 dark:text-gray-400 text-sm">No data available</p>
        </div>
      </Card>
    );
  }

  return (
    <Card extra="p-5">
      <h4 className="text-base font-bold text-navy-700 dark:text-white mb-1 font-dm">
        Top Retailers by Crawl Count
      </h4>
      <p className="text-xs text-gray-500 dark:text-gray-400 mb-2 font-dm">
        Top {retailerData.length} most crawled retailers
      </p>
      <Chart
        type="bar"
        height={Math.max(280, retailerData.length * 36)}
        series={[{ name: "Crawls", data: retailerData.map((d) => d.count) }]}
        options={{
          chart: {
            type: "bar",
            toolbar: { show: false },
            fontFamily: "DM Sans, sans-serif",
          },
          plotOptions: {
            bar: {
              horizontal: true,
              borderRadius: 4,
              barHeight: "65%",
              distributed: true,
            },
          },
          colors: [
            "#4f46e5", "#7c3aed", "#2563eb", "#0891b2", "#059669",
            "#d97706", "#dc2626", "#db2777", "#9333ea", "#6366f1",
          ],
          dataLabels: {
            enabled: true,
            style: { fontSize: "11px", fontFamily: "DM Sans, sans-serif", colors: ["#fff"] },
          },
          xaxis: {
            categories: retailerData.map((d) =>
              d.name.length > 28 ? d.name.slice(0, 25) + "..." : d.name
            ),
            labels: { style: { fontSize: "11px" } },
          },
          yaxis: {
            labels: {
              style: { fontSize: "11px", fontFamily: "DM Sans, sans-serif" },
              maxWidth: 180,
            },
          },
          grid: {
            borderColor: "#e5e7eb",
            strokeDashArray: 4,
            xaxis: { lines: { show: true } },
            yaxis: { lines: { show: false } },
          },
          legend: { show: false },
          tooltip: { theme: "dark" },
        }}
      />
    </Card>
  );
};

export default CrawlerTopRetailersChart;
